import { Base } from "ui/Scripts/source/framework/base";

export interface IDocumentListItem {
    id: string;
    fileType: number;
    image: string;
    code: string;
    modifyDate: number;
    modifyName: string;
    permission: number;
    isFolder: boolean;
    isFavorite: boolean;
    isTitle: boolean;
    documentVersionId: string;
}

export class DocumentListItem implements IDocumentListItem {
    id: string;
    fileType: number;
    image: string;
    code: string;
    modifyDate: number;
    modifyName: string;
    permission: number;
    isFolder: boolean;
    isFavorite: boolean;
    isTitle: boolean;
    documentVersionId: string;

    constructor();
    constructor(obj: IDocumentListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.fileType = obj && obj.fileType || 0;
        this.image = obj && obj.image || "";
        this.code = obj && obj.code || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.modifyName = obj && obj.modifyName || "";
        this.permission = obj && obj.permission || 0;
        this.isFolder = obj && obj.isFolder || false;
        this.isFavorite = obj && obj.isFavorite || false;
        this.isTitle = obj && obj.isTitle || false;
        this.documentVersionId = obj && obj.documentVersionId || "";
    }

    static getTitleMessageListItem(title: string): DocumentListItem {
        const result = new DocumentListItem();
        result.id = Base.getGuid();
        result.code = title;
        result.isTitle = true;
        return result;
    }
}

export interface IDocumentListParentItem extends IDocumentListItem {
    parentId: string;

    getIsRoot(): boolean;
}

export class DocumentListParentItem implements IDocumentListParentItem {
    parentId: string;
    id: string;
    fileType: number;
    image: string;
    code: string;
    modifyDate: number;
    modifyName: string;
    permission: number;
    isFolder: boolean;
    isFavorite: boolean;
    isTitle: boolean;
    documentVersionId: string;

    constructor();
    constructor(obj: IDocumentListItem);
    constructor(obj?: any) {
        this.parentId = obj && obj.parentId || "";
        this.id = obj && obj.id || "";
        this.fileType = obj && obj.fileType || 0;
        this.image = obj && obj.image || "";
        this.code = obj && obj.code || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.modifyName = obj && obj.modifyName || "";
        this.permission = obj && obj.permission || 0;
        this.isFolder = obj && obj.isFolder || false;
        this.isFavorite = obj && obj.isFavorite || false;
        this.isTitle = obj && obj.isTitle || false;
        this.documentVersionId = obj && obj.documentVersionId || "";
    }

    getIsRoot(): boolean {
        return Base.isNullOrEmpty(this.parentId);
    }
}
